export interface WebsiteShellState {
    defination: Idefination;
    mega_menu: IMegaMenu;
    projects: IProject[];
    seo_projects: ISeoProjects[];
    project: any;
    latest_projects: any[];
    all_projects: IProject[];
    project_menus: IProjectMenus[];
    student_details: any;
    error: IError;
}

export const initialState: WebsiteShellState = {
    defination:null,
    mega_menu: null,
    projects: null,
    seo_projects: null,
    project: null,
    latest_projects: null,
    all_projects: null,
    project_menus: null,
    student_details: null,
    error: {
        defination_error: null,
        mega_menu_error: null,
        projects_error: null,
        seo_projects_error: null,
        project_error: null,
        latest_projects_error: null,
        all_projects_error: null,
        project_menus_error: null
    }
};

export interface IError {
    defination_error: any;
    mega_menu_error: any;
    projects_error: any;
    seo_projects_error: any;
    project_error: any;
    latest_projects_error: any;
    all_projects_error: any;
    project_menus_error: any;
}

export interface IMegaMenu {
    pg: IPg[],
    ug: IUg[],
    inter: IInter[],
    school: ISchool[]
}

export interface IPg {
    dept_id: number;
    mid: number;
    dept_name: string;
    domain_id: number;
    domain_name: string;
    tech_id: number;
    tech_name: string;
}

export interface IUg {
    dept_id: number;
    dept_name: string;
    mid: number;
    menu_name: string;
    oid: number;
    organ_name: string;
    domain_id: number;
    domain_name: string;
    tech_id: number;
    tech_name: string;
}

export interface IInter {
    dept_id: number;
    dept_name: string;
    mid: number;
    menu_name: string;
    domain_id: number;
    domain_name: string;
    tech_id: number;
    tech_name: string;
}

export interface ISchool {
    dept_id: number;
    dept_name: string;
    mid: number;
    menu_name: string;
    domain_id: number;
    domain_name: string;
    tech_id: number;
    tech_name: string;
}

export interface IProject {
    dept_id: string;
    dept_public_link: string;
    dept_name: string;
    mid: number;
    m_public_link: string;
    main_menu: string;
    sid: number;
    s_public_link: string;
    second_menu: string;
    thirdid: number;
    priority_id: string;
    t_public_link: string;
    third_menu: string;
    title_id: number;
    project_code: string;
    title_name: string;
    pro_content: string;
    sector: string;
    organzise: string;
    oid: number;
    year: number;
    objective: string;
}

export interface ISeoProjects {
    dept_id: string;
    dept_public_link: string;
    dept_name: string;
    mid: number;
    m_public_link: string;
    main_menu: string;
    sid: number;
    s_public_link: string;
    second_menu: string;
    thirdid: number;
    priority_id: string;
    t_public_link: string;
    third_menu: string;
    title_id: number;
    project_code: string;
    title_name: string;
    pro_content: string;
    sector: string;
    organzise: string;
    oid: number;
    year: number;
    tid: number;
    title_public_link: string;
    objective: string;
}

export interface IProjectMenus {
    dept_id: string;
    dept_public_link: string;
    dept_name: string;
    mid: number;
    m_public_link: string;
    main_menu: string;
    sid: number;
    s_public_link: string;
    second_menu: string;
    thirdid: number;
    t_public_link: string;
    third_menu: string;
}


export interface Idefination {
    marketing_content: string;
    technical_content: string;
}